import { render, staticRenderFns } from "./MediaIcon.vue?vue&type=template&id=1f8827ae&scoped=true"
import script from "./MediaIcon.vue?vue&type=script&lang=ts"
export * from "./MediaIcon.vue?vue&type=script&lang=ts"
import style0 from "./MediaIcon.vue?vue&type=style&index=0&id=1f8827ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8827ae",
  null
  
)

export default component.exports